/**
 * Unity Tags File Renderer
 * Generates TagElement class and static Tags class with all tag data
 */

/**
 * Render tags file for Unity C# exports
 * Generates TagElement class and static Tags class with all tag data
 * 
 * @param tags - Array of tag groups with data
 * @param namespace - C# namespace (default: 'Grimoire.Data')
 * @param className - Class name for the static tags class (default: 'Tags')
 */
export function renderTagsFile(
  tags: any[],
  namespace: string = 'Grimoire.Data',
  className: string = 'Tags'
): string {
  console.log(`🏷️ Rendering tags file for namespace: ${namespace}`);
  console.log(`📊 Processing ${tags.length} tag groups`);
  
  let output = '// Auto-generated Tags\n';
  output += '// This file is AUTO-GENERATED and can be safely regenerated.\n';
  output += '// DO NOT EDIT THIS FILE DIRECTLY - your changes will be lost.\n\n';
  output += `namespace ${namespace}\n{\n`;
  
  // Generate TagElement class
  output += '\tpublic sealed class TagElement\n\t{\n';
  output += '\t\tpublic string Id;\n';
  output += '\t\tpublic string Name;\n';
  output += '\t\tpublic string Code;\n';
  output += '\t\tpublic string Value;\n';
  output += '\t}\n\n';
  
  // Generate Tags static class
  output += `\tpublic static class ${className}\n\t{\n`;
  
  // Process each tag group
  tags.forEach((tagGroup, groupIndex) => {
    if (!tagGroup.data || !Array.isArray(tagGroup.data) || tagGroup.data.length === 0) {
      return;
    }
    
    // Get tag group name (sanitize for C# class name)
    const tagGroupName = (tagGroup.name || `Group${groupIndex}`)
      .replace(/[^a-zA-Z0-9_]/g, '_');
    
    console.log(`  🏷️ Processing tag group: ${tagGroupName} (${tagGroup.data.length} elements)`);
    
    output += `\t\tpublic static class ${tagGroupName}\n\t\t{\n`;
    
    // Process each tag element in the group
    tagGroup.data.forEach((element: any) => {
      const elementName = (element.name || element.id || 'Unknown')
        .replace(/[^a-zA-Z0-9_]/g, '_');
      
      const elementId = element.id || '';
      const elementCode = element.code || element.name || '';
      const elementValue = element.value || '';
      
      // Escape strings for C#
      const escapedId = elementId.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
      const escapedName = (element.name || '').replace(/\\/g, '\\\\').replace(/"/g, '\\"');
      const escapedCode = elementCode.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
      const escapedValue = elementValue.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
      
      output += `\t\t\tpublic static readonly TagElement ${elementName} = new()\n\t\t\t{\n`;
      output += `\t\t\t\tId = "${escapedId}",\n`;
      output += `\t\t\t\tName = "${escapedName}",\n`;
      output += `\t\t\t\tCode = "${escapedCode}",\n`;
      output += `\t\t\t\tValue = "${escapedValue}"\n`;
      output += '\t\t\t};\n\n';
    });
    
    output += '\t\t}\n\n';
  });
  
  output += '\t}\n';
  output += '}\n';
  
  console.log('✅ Tags file rendered successfully');
  
  return output;
}
